export const FLOW_CONTEXT_NAMES_CONSTANTS = {
  flowList: 'flow-list',
  folder: 'folder',
};
